import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f15c4270"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zones-grid" }
const _hoisted_2 = {
  key: 0,
  class: "zones-grid__state"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-red-500 text-sm" }, "При получении данных произошла ошибка", -1))
const _hoisted_4 = {
  key: 1,
  class: "zones-grid__container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.3983 11.9991C5.3983 12.9543 4.6223 13.7287 3.6671 13.7287C2.7119 13.7287 1.9375 12.9543 1.9375 11.9991C1.9375 11.0439 2.7119 10.2695 3.6671 10.2695C4.62391 10.2695 5.3983 11.0439 5.3983 11.9991Z",
    fill: "#3B82F6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.2296 13.7287C13.1848 13.7287 13.9592 12.9544 13.9592 11.9991C13.9592 11.0439 13.1848 10.2695 12.2296 10.2695C11.2744 10.2695 10.5 11.0439 10.5 11.9991C10.5 12.9544 11.2744 13.7287 12.2296 13.7287Z",
    fill: "#3B82F6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.3345 7.65802L13.3846 5.4944C13.2843 5.26607 13.0585 5.11861 12.8091 5.11861H9.70152V3.89795C9.70152 3.55088 9.42017 3.26953 9.07311 3.26953H1.02881C0.681743 3.26953 0.400391 3.55088 0.400391 3.89795V11.1592C0.400391 11.5063 0.681743 11.7876 1.02881 11.7876H1.59587C1.70227 10.7368 2.58944 9.91674 3.66839 9.91674C4.74759 9.91674 5.63502 10.7365 5.74116 11.7876H9.28732H9.70152H10.1565C10.2627 10.7368 11.1501 9.91674 12.229 9.91674C13.3082 9.91674 14.1954 10.7365 14.3018 11.7876H14.972C15.319 11.7876 15.6004 11.5063 15.6004 11.1592V8.91847C15.6004 8.72022 15.5068 8.5336 15.348 8.41497L14.3345 7.65802ZM10.2467 8.14898V5.74992H12.8226L13.7939 8.14898L10.2467 8.14898Z",
    fill: "#3B82F6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.5257 8.39953L11.0346 8.49816L10.8096 7.37792C10.7824 7.24232 10.8703 7.11031 11.0059 7.08308C11.1415 7.05584 11.2735 7.14369 11.3007 7.27929L11.5257 8.39953Z",
    fill: "#3B82F6"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.83155 15H4.99968C4.91609 15 4.83385 14.979 4.76046 14.939C4.68708 14.899 4.6249 14.8412 4.57961 14.7709C4.53432 14.7007 4.50736 14.6202 4.5012 14.5368C4.49505 14.4535 4.50989 14.3699 4.54437 14.2937L6.55874 9.84844L3.53405 9.78125L2.43093 11.1178C2.22062 11.3822 2.0528 11.5 1.62468 11.5H1.06468C0.976014 11.5029 0.887967 11.4843 0.808001 11.4459C0.728034 11.4075 0.658505 11.3504 0.605304 11.2794C0.530929 11.1791 0.457804 11.0091 0.529054 10.7666L1.14843 8.54781C1.15312 8.53125 1.15874 8.51469 1.16499 8.49844C1.1653 8.49689 1.1653 8.4953 1.16499 8.49375C1.15854 8.47751 1.15301 8.46092 1.14843 8.44406L0.528429 6.21125C0.461241 5.97344 0.534679 5.80719 0.608429 5.70937C0.657953 5.64366 0.722204 5.59049 0.796018 5.55412C0.869831 5.51776 0.951148 5.49922 1.03343 5.5H1.62468C1.94437 5.5 2.25468 5.64344 2.43718 5.875L3.51749 7.18906L6.55874 7.14406L4.54499 2.70656C4.51046 2.63045 4.49557 2.5469 4.50166 2.46355C4.50775 2.3802 4.53464 2.2997 4.57987 2.22942C4.62509 2.15914 4.68721 2.10132 4.76055 2.06124C4.83389 2.02116 4.9161 2.00011 4.99968 2H5.84062C5.95794 2.00236 6.07322 2.03111 6.1779 2.08413C6.28259 2.13715 6.37398 2.21307 6.4453 2.30625L10.3531 7.05625L12.1584 7.00875C12.2906 7.00156 12.6569 6.99906 12.7416 6.99906C14.4684 7 15.4997 7.56063 15.4997 8.5C15.4997 8.79563 15.3816 9.34375 14.5912 9.6925C14.1247 9.89875 13.5022 10.0031 12.7409 10.0031C12.6572 10.0031 12.2919 10.0006 12.1578 9.99344L10.3528 9.94531L6.4353 14.6953C6.36392 14.7881 6.27261 14.8636 6.16811 14.9164C6.0636 14.9691 5.94859 14.9977 5.83155 15Z",
    fill: "#3B82F6"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.83155 15H4.99968C4.91609 15 4.83385 14.979 4.76046 14.939C4.68708 14.899 4.6249 14.8412 4.57961 14.7709C4.53432 14.7007 4.50736 14.6202 4.5012 14.5368C4.49505 14.4535 4.50989 14.3699 4.54437 14.2937L6.55874 9.84844L3.53405 9.78125L2.43093 11.1178C2.22062 11.3822 2.0528 11.5 1.62468 11.5H1.06468C0.976014 11.5029 0.887967 11.4843 0.808001 11.4459C0.728034 11.4075 0.658505 11.3504 0.605304 11.2794C0.530929 11.1791 0.457804 11.0091 0.529054 10.7666L1.14843 8.54781C1.15312 8.53125 1.15874 8.51469 1.16499 8.49844C1.1653 8.49689 1.1653 8.4953 1.16499 8.49375C1.15854 8.47751 1.15301 8.46092 1.14843 8.44406L0.528429 6.21125C0.461241 5.97344 0.534679 5.80719 0.608429 5.70937C0.657953 5.64366 0.722204 5.59049 0.796018 5.55412C0.869831 5.51776 0.951148 5.49922 1.03343 5.5H1.62468C1.94437 5.5 2.25468 5.64344 2.43718 5.875L3.51749 7.18906L6.55874 7.14406L4.54499 2.70656C4.51046 2.63045 4.49557 2.5469 4.50166 2.46355C4.50775 2.3802 4.53464 2.2997 4.57987 2.22942C4.62509 2.15914 4.68721 2.10132 4.76055 2.06124C4.83389 2.02116 4.9161 2.00011 4.99968 2H5.84062C5.95794 2.00236 6.07322 2.03111 6.1779 2.08413C6.28259 2.13715 6.37398 2.21307 6.4453 2.30625L10.3531 7.05625L12.1584 7.00875C12.2906 7.00156 12.6569 6.99906 12.7416 6.99906C14.4684 7 15.4997 7.56063 15.4997 8.5C15.4997 8.79563 15.3816 9.34375 14.5912 9.6925C14.1247 9.89875 13.5022 10.0031 12.7409 10.0031C12.6572 10.0031 12.2919 10.0006 12.1578 9.99344L10.3528 9.94531L6.4353 14.6953C6.36392 14.7881 6.27261 14.8636 6.16811 14.9164C6.0636 14.9691 5.94859 14.9977 5.83155 15Z",
    fill: "#3B82F6"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_block = _resolveComponent("block")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading || _ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary"
              }))
            : (_ctx.failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_3,
                  _createVNode(_component_the_button, {
                    class: "primary small",
                    onClick: _ctx.onRefresh
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Попробовать еще раз")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_block, {
            title: "Авто",
            "is-auto": "",
            "zone-id": _ctx.zoneId,
            tariffs: _ctx.autoTariffs
          }, {
            icon: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["zone-id", "tariffs"]),
          (_ctx.zoneId === 6 || _ctx.zoneId === 7)
            ? (_openBlock(), _createBlock(_component_block, {
                key: 0,
                title: "Авиа",
                "is-avia": "",
                "zone-id": _ctx.zoneId,
                tariffs: _ctx.autoTariffs
              }, {
                icon: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["zone-id", "tariffs"]))
            : (_openBlock(), _createBlock(_component_block, {
                key: 1,
                title: "Авиа",
                "is-avia": "",
                "zone-id": _ctx.zoneId,
                tariffs: _ctx.aviaTariffs
              }, {
                icon: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["zone-id", "tariffs"]))
        ]))
  ]))
}